import React from 'react';

// tslint:disable:max-line-length
const DuedateIcon = (props) => (
  <svg width={13} height={13} viewBox="0 0 13 13" {...props}>
    <g fillRule="nonzero" fill={props.color || 'currentColor'}>
      <path d="M10.584 6.041a4.541 4.541 0 1 0-9.084 0 4.542 4.542 0 1 0 9.084 0zm1.5 0A6.042 6.042 0 1 1 0 6.041a6.042 6.042 0 0 1 12.084 0z" />
      <path d="M4.062 5.957a.75.75 0 0 0 0 1.5h2.74L6.75 3.101a.75.75 0 1 0-1.5.018l.034 2.838H4.062z" />
    </g>
  </svg>
);
// tslint:enable:max-line-length

export default DuedateIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/DuedateIcon.js